import { LOAD_FEATURE_USER_SETTINGS } from 'actions/actionTypes';
import { getFeatureUserSettings } from 'api/featureUserSettings';
import {
  getFeatureUserSettingsSuccess,
  getFeatureUserSettingsFailure,
  updateFeatureUserSettings,
} from 'actions';
import { toInteger, get } from 'lodash';
import { apiPromise } from './apiPromise';

const transformFeatureUserSettings = settings => {
  const key = toInteger(get(settings, 'key', 0));
  const customerId = toInteger(get(settings, 'custom.customerId', 0));
  const { custom: customFields, ...userFields } = settings;

  return {
    ...userFields,
    key,
    custom: {
      ...customFields,
      customerId,
    }
  };
};

export const featureUserSettings = store => next => (action) => {
  switch (action.type) {
    case LOAD_FEATURE_USER_SETTINGS.REQUEST:
    {
      next(action);
      return apiPromise(
        store,
        action,
        getFeatureUserSettings,
        [],
        getFeatureUserSettingsSuccess,
        getFeatureUserSettingsFailure
      );
    }
    case LOAD_FEATURE_USER_SETTINGS.SUCCESS: {
      const { dispatch } = store;
      const { launchDarklySettings: settings } = get(action, 'payload', undefined);

      if (settings) {
        const transformedSettings = transformFeatureUserSettings(settings);
        dispatch(updateFeatureUserSettings(transformedSettings));
      }

      next(action);
      return Promise.resolve();
    }
    default:
      next(action);
      return Promise.resolve();
  }
};

export default featureUserSettings;
